import { useState, useCallback } from 'react'

import { useHistory } from 'react-router-dom'

import { twoFactorVerification } from '../services/api'

import { useSetCredentials } from '../components/CredentialsProvider'
import { useSecurityConfig } from '../components/SecurityConfigProvider'

export const useTwoFactorAtuh = () => {
    const securityConfig = useSecurityConfig()
    const setSecurity = useSetCredentials()
    const history = useHistory()

    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [error, setError] = useState<string>('')

    const handleTowFactorVerification = useCallback(({ code }) => {
        setIsLoading(true)

        twoFactorVerification(code)
            .then(({ user, token, refreshToken }) => {
                setSecurity({ authentication: user, token, refreshToken }, 'local')

                history.push(securityConfig.successPath)
            })
            .catch((error) => {
                setError(error.message)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }, [setSecurity, setError, setIsLoading])

    return {
        error,
        isLoading,
        handleTowFactorVerification
    }
}

